import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import qs from 'qs';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { notifyPdfLoadedSection } from '../../../../../../../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../../../../../../../PDFRenderer/PDFRendererTypes';

export interface ComparePlanDTO {
  totalNetWorthAtRetirement: number;
  totalNetWorthEndOfPlan: number;
  isGoalFunded: boolean;
  probabilityOfSuccess: number;
  retirementAgePrincipal: number | null;
  retirementAgeSpouse: number | null;
  lifeExpectancyPrincipal: number | null;
  lifeExpectancySpouse: number | null;
  livingExpense: number;
  additionalSavingPerMonth: number;
  earmarkedAssetsAtRetirement: number;
  firstYearRetirementIncome: number;
  firstYearRetirementIncomeAnnuities: number;
  firstYearRetirementIncomeSocialSecurity: number;
  firstYearRetirementIncomePension: number;
  firstYearRetirementIncomeDistributions: number;
  firstYearRetirementIncomeOther: number;
  firstYearRetirementExpense: number;
  firstYearRetirementExpenseLiabilities: number;
  firstYearRetirementExpenseTaxes: number;
  socialSecurityFilingAgeYear: number | null;
  socialSecurityFilingAgeMonth: number | null;
  socialSecurityFilingAgeYearSpouse: number | null;
  socialSecurityFilingAgeMonthSpouse: number | null;
  totalLifetimeSocialSecurityBenefits: number;
  inflationRate: number;
  preRetirementAssetAllocation: string;
  preRetirementRateOfReturn: number;
  preRetirementStandardDeviation: number;
  postRetirementAssetAllocation: string;
  postRetirementRateOfReturn: number;
  postRetirementStandardDeviation: number;
}

const fetchComparePlansData = async (
  clientId: string,
  planIds: string[],
): Promise<ComparePlanDTO[]> => {
  const planIdsEncoded = qs.stringify({ planIds }, { arrayFormat: 'repeat' });

  return authFetch(`/Consumer/ComparePlan?clientId=${clientId}&${planIdsEncoded}`);
};

interface ComparePlansQueryParams {
  clientId: string;
  planIds: string[];
}

export const useComparePlansQuery = ({ clientId, planIds }: ComparePlansQueryParams) => {
  const dispatch = useDispatch();

  return useQuery(
    queryKeys.comparePlans(clientId, planIds),

    () => fetchComparePlansData(clientId, planIds),

    {
      enabled: Array.isArray(planIds) && planIds.length > 1,

      onSuccess() {
        dispatch(notifyPdfLoadedSection(PdfSectionType.ComparePlans));
      },
    },
  );
};
